/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_CancelingInputs */

const en_settings_billing_canceling = /** @type {(inputs: Settings_Billing_CancelingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceling...`)
};

/**
* | output |
* | --- |
* | "Canceling..." |
*
* @param {Settings_Billing_CancelingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_canceling = /** @type {((inputs?: Settings_Billing_CancelingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_CancelingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_canceling(inputs)
});
export { settings_billing_canceling as "settings.billing.canceling" }